<script setup lang="ts">
import { useEventLogStore } from '@/stores/event';
import { DATA_QA } from './phone-change-log.constants';
import { watch } from 'vue';
import PhoneChangeLogItem from '../PhoneChangeLogItem/PhoneChangeLogItem.vue';
import { PhoneFromJSON } from '@/apis/generated/dialbunny';
import type { EventLog, Phone } from '@/apis/generated/dialbunny';

type Props = {
  phoneId: string | null;
};

const props = defineProps<Props>();

const eventLogStore = useEventLogStore();

watch(
  () => props.phoneId,
  (value) => {
    if (!value) return;
    eventLogStore.filter = {
      subjectId: value,
      tags: 'dnx',
    };
  },
  { immediate: true },
);

const getPhone = (item: EventLog | undefined): Phone | null =>
  PhoneFromJSON(item?.subject ?? null) as Phone | null;
</script>
<template>
  <div
    :data-qa="DATA_QA.ROOT"
    :data-qa-loading="eventLogStore.loading"
    class="d-ml16 d-mt12 d-d-flex d-fd-column-reverse"
  >
    <PhoneChangeLogItem
      v-for="(item, i) in eventLogStore.data"
      :key="item.id"
      :prev-phone="getPhone(eventLogStore.data[i - 1])"
      :phone="getPhone(item)"
      :initial="i === 0"
    />
  </div>
</template>
